import Modal from 'bootstrap/js/src/modal';
import Newsletter from './newsletter/Newsletter';

class Modals {
	constructor() {
		this.init();
	}

	init() {
		this.newsletterForCalendar();
		this.initEvents();
	}

	initEvents() {
		const videoModal = document.querySelector('.modal.video');

		if (videoModal) {
			videoModal.addEventListener('hidden.bs.modal', () => {
				const videoIframe = videoModal.querySelector('.youtube-video');

				if (videoIframe) {
					videoIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
				}
			});
		}

		document.addEventListener('show.bs.modal', (ev) => {
			this.initHistoryHandling(ev.target);
		});
	}

	initHistoryHandling(modalElement) {
		const modal = Modal.getOrCreateInstance(modalElement),
			disableHash = modalElement.dataset.disablehash,
			onPopstate = () => {
				modal.hide();
			};

		if (!disableHash) {
			this.pushModalToHistory(modalElement);

			window.addEventListener('popstate', () => {
				modalElement.removeEventListener('hide.bs.modal', onPopstate);
			}, {'once': true});

			modalElement.addEventListener('hide.bs.modal', () => {
				if (history.state && history.state.isModalOpen) {
					window.removeEventListener('popstate', onPopstate);
					history.back();
				}
			}, {'once': true});
		}
	}

	pushModalToHistory(modalElement) {
		const [hrefWithoutHash] = location.href.split('#');

		history.pushState(
			{
				'isModalOpen': true
			},
			null,
			`${hrefWithoutHash}#${modalElement.id}`
		);
	}

	newsletterForCalendar() {
		const modals = {
				'calendar' : document.querySelector('#emptymonthNewsletterModal'),
				'seasonEnd': document.querySelector('#customSeasonEndPopUpModal')
			},
			openEmptymonthNewsletterModal = document.querySelector('.openEmptymonthNewsletterModal');

		if (openEmptymonthNewsletterModal) {
			openEmptymonthNewsletterModal.addEventListener('click', () => {
				modals.calendar.show();
			});
		}

		if (
			typeof window.CustomSeasonEndPopUp !== 'undefined' &&
			!window.CustomSeasonEndPopUp.hasArrangementBlock
		) {
			this.loadModalEvents(modals.seasonEnd);
		}

		if (modals.calendar) {
			this.loadModalEvents(modals.calendar);
		}
	}

	/**
	 * @param {!HTMLElement} modalElement
	 */
	loadModalEvents(modalElement) {
		if (!modalElement) {
			return;
		}

		modalElement.addEventListener('shown.bs.modal', () => {
			new Newsletter(
				modalElement.querySelector('.newsletter-form')
			);
		}, {'once': true});
		
		modalElement.addEventListener('shown.bs.modal', () => {
			const emailInput = modalElement.querySelector('input[name="email"]');

			emailInput.focus();
		});
	}

}

export default Modals;